import { Tooltip } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";

const OverflowTip = ({ children, component: Component = "div", ...props }) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef();
  useEffect(() => {
    setIsOverflow(
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth,
    );
  }, []);

  return (
    <Tooltip title={children} disableHoverListener={!isOverflowed}>
      <Component
        ref={textElementRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...props.style,
        }}
        {...props}
      >
        {children}
      </Component>
    </Tooltip>
  );
};

export default OverflowTip;
